import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import Home from './scenes/Home'
import Articles from './scenes/Articles'
import WriteArticles from './scenes/WriteArticle'
import Article from './scenes/Article'
import ArticlesAdmin from './scenes/ArticlesAdmin'
import About from './scenes/About'
import Contact from './scenes/Contact'
import Login from './scenes/Login'

const Routes = () => {
  return (
  <Switch>
    <Route exact path="/" render={Home} />
    <Route exact path="/about/" component={About} />
    <Route exact path="/articles/" component={Articles} />
    <Route exact path="/articles/edit/:id" component={WriteArticles} />
    <Route path={"/articles/admin"} component={ArticlesAdmin} />
    <Route path={"/articles/:id"} component={Article} />
    <Route exact path="/contact/" component={Contact} />
    <Route exact path="/login/" component={Login} />
    <Redirect to="/" />
  </Switch>
)}

export default Routes